@let layout = store.layoutSg();
@let status = store.statusSg();

<div
  #viewport
  class="atn-ds-table-data__viewport"
  (scroll)="viewportScrollHandler($event)"
>
  @if (status) {
    <atn-ds-table-status [status]="status" />
  } @else {
    <div
      class="atn-ds-table-data__content"
      [style.width.px]="layout.contentWidthPx"
    >
      <atn-ds-table-column-headers />
      <atn-ds-table-rows />
    </div>
  }
</div>
